// extracted by mini-css-extract-plugin
module.exports = {"noSpinner":"numInput_noSpinner__yH_ej"};